import { User } from "@/auth/AuthContext";

/** Check if user has a specific role/group */
export function hasRole(user: User | null, roleName: string): boolean {
  if (!user || !user.roles) return false;
  return user.roles.some((role) => role.id === roleName || role.name === roleName);
}

/** Check if user can access an app given its required roles */
export function canAccessApp(user: User | null, requiredRoles: string[]): boolean {
  if (!requiredRoles || requiredRoles.length === 0) return true;
  if (!user) return false;
  return requiredRoles.some((role) => hasRole(user, role));
}
